import { render, staticRenderFns } from "./center-container.vue?vue&type=template&id=e568fc0a&scoped=true&"
import script from "./center-container.vue?vue&type=script&lang=js&"
export * from "./center-container.vue?vue&type=script&lang=js&"
import style0 from "./center-container.vue?vue&type=style&index=0&id=e568fc0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e568fc0a",
  null
  
)

export default component.exports